import React from "react";
import "./ConfigurationTabs.css";

const ConfigurationTabs = ({ activeTab, setActiveTab, tabs, children }) => {
  return (
    <div className="configuration-tabs">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;

        const handleTabClick = () => {
          if (tab.disabled) {
            if (tab.onDisabledClick) {
              tab.onDisabledClick();
            }
            return;
          }
          setActiveTab(tab.id);
        };

        return (
          <button
            key={tab.id}
            type="button"
            className={`tab-button ${isActive ? "active" : ""} ${tab.disabled ? "tab-disabled" : ""}`}
            onClick={handleTabClick}
          >
            <div className="btn-wrapper">
              <img
                src={isActive ? tab.iconActive : tab.iconInactive}
                alt={tab.iconAlt || tab.label}
                className={tab.iconClassName}
              />
              <span className="title-btn">{tab.label}</span>
            </div>
          </button>
        );
      })}
      {children}
    </div>
  );
};

export default ConfigurationTabs;
